import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

import EncounterTCode from './EncounterTCode';
const Api = require('./Config');

const EncounterPatient = ({
  show,
  patientRef,
  patientId,
  allStatus,
  onClose,
  onESViewClick,
  onMailClick,
  onNoteSave,
  onStatusChange,
  role,
}) => {
  const [patientTCodes, setPatientTCodes] = useState([]);

  useEffect(() => {
    (async () => {
      if (patientId) {
        const result = await Api.getAllTCodesForPatient(patientId);
        setPatientTCodes(result.t_codes);
      }
    })();
    return () => {
      setPatientTCodes([]);
    };
  }, [patientId]);

  return (
    <Modal show={show} onHide={onClose} dialogClassName="modal-encounter-patient" restoreFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title>Medical Pt #{patientRef}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto',
        }}
      >
        {patientTCodes.map((tCode, idx) => {
          return (
            <React.Fragment key={tCode.TID}>
              <EncounterTCode
                key={tCode.TID}
                data={tCode}
                t_code={tCode.t_code}
                allStatus={allStatus}
                allJourneyNames={[tCode.journey_name]}
                allApps={[tCode.app_id]}
                onESViewClick={onESViewClick}
                onMailClick={onMailClick}
                onNoteSave={onNoteSave}
                onStatusChange={onStatusChange}
                role={role}
              />
              {patientTCodes.length - 1 !== idx && <hr></hr>}
            </React.Fragment>
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={onClose} className="btn btn-info">
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EncounterPatient;
